
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DirectivesModule } from './directives.module';
import { LoadingComponent } from './components/loading/loading.component';
import { DialogInputComponent } from './components/dialog-input/dialog-input.component';
import { NgxSpinnerModule } from 'ngx-spinner';
import { DateTimeHelperService } from './services/date-time-helper.service';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { ToastComponent } from './components/toast/toast.component';
import { DialogHostComponent } from './components/dialog-host/dialog-host.component';
import { EmptyStateComponent } from './components/empty-state/empty-state.component';
import { PaginatorComponent } from './directives/paginator.component';
import { SortableHeaderDirective } from './directives/sortable-header.directive';

@NgModule({
    declarations: [
        LoadingComponent,
        DialogInputComponent,
        ToastComponent,
        DialogHostComponent,
        EmptyStateComponent,
        PaginatorComponent,
        SortableHeaderDirective
    ],

    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        DirectivesModule,
        FontAwesomeModule,
        NgxSpinnerModule.forRoot({ type: 'ball-scale-multiple' })
    ],
    providers:[
        DateTimeHelperService
    ],
    exports: [
        CommonModule,
        FormsModule,
        LoadingComponent,
        DialogInputComponent,
        ToastComponent,
        DialogHostComponent,
        EmptyStateComponent,
        PaginatorComponent,
        SortableHeaderDirective,
        ReactiveFormsModule,
        FontAwesomeModule,
        NgxSpinnerModule
    ]
})
export class SharedModule { }
